import script from "./select-option.vue?vue&type=script&setup=true&lang=ts"
export * from "./select-option.vue?vue&type=script&setup=true&lang=ts"

import "./select-option.vue?vue&type=style&index=0&id=584ec1f7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584ec1f7"]])

export default __exports__